export const checkCurrentPage = (page: string, pathname = '', secondPath = '', thirdPath = '', fourthPath = '') => {
    function removeIdOrDigitsAfterSlash(inputString: string) {
        return inputString?.replace(/\/(:\w+|\d+)(\?|$)/, '/');
    }

    if (removeIdOrDigitsAfterSlash(pathname) === removeIdOrDigitsAfterSlash(page)) {
        return true;
    } else if (pathname === secondPath || pathname === thirdPath || pathname === fourthPath) {
        return true;
    } else {
        return false;
    }
};

export const digitPattern = /^[\d+]*$/;


export const getBackendBaseUrl = () => {
    return process.env.REACT_APP_SERVER_API_URL
};
export const getFrontendBaseUrl = () => {
    return window.location.origin;
};